import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
	const { i18n } = useTranslation();
	const availableLanguages = useMemo(() => ['en', 'nl', 'fr'], []);

	const handleChangeLanguage = (language: string) => {
		i18n.changeLanguage(language);
		localStorage.setItem('lang', language);
		window.history.replaceState(
			null,
			'',
			`${window.location
				.toString()
				.replace(window.location.search, '')}?lang=${language}`
		);
		document.querySelector('html')?.setAttribute('lang', language);
	};

	return (
		<ul className='language-switcher'>
			{availableLanguages.map((language) => (
				<li
					key={language}
					className={classNames('language-switcher__item', {
						'language-switcher__item--active': i18n.language === language,
					})}
					onClick={() => handleChangeLanguage(language)}
				>
					{language}
				</li>
			))}
		</ul>
	);
}

export default LanguageSwitcher;
